import SeoHead from "@/components/common/layout/seo-head";
import PrivacyPolicy from "@/components/v2/agreement/privacy-policy";
import { getAgreeLayout } from "@/components/v2/layout/agree-layout";
import { V2_AGREE_LAYOUT_TYPE } from "@/types/layout";
import style from "../agree.module.css";

const PrivacyPolicyPage = () => {
  return (
    <>
      <SeoHead title="개인정보처리방침" />
      <div className={style.article}>
        <h1 className="site-layout-title-simple">개인정보처리방침</h1>
        <PrivacyPolicy />
      </div>
    </>
  );
};

PrivacyPolicyPage.getLayout = getAgreeLayout(V2_AGREE_LAYOUT_TYPE.DEFAULT);
export default PrivacyPolicyPage;
